import { lazy, Suspense, useState } from 'react';
import type { WidgetCreatorProps } from './WidgetCreatorDialog';

const WidgetCreatorDialog = lazy(() =>
    import('./WidgetCreatorDialog').then((module) => ({ default: module.WidgetCreatorDialog }))
);

/**
 * The creator, fetched the first time it is opened: it builds with the filters of four lists, which Home has no
 * other use for.
 */
export function WidgetCreator(props: WidgetCreatorProps) {
    const [wanted, setWanted] = useState(props.open);
    if (props.open && !wanted) {
        setWanted(true);
    }
    return wanted ? (
        <Suspense fallback={null}>
            <WidgetCreatorDialog {...props} />
        </Suspense>
    ) : null;
}
